import { c as _c } from "react/compiler-runtime";
import { CircularProgress } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Size (height and width) of the circular progress in pixels */
const CIRCULAR_PROGRESS_SIZE = "18px";

/** Thickness for the circular progress, it is unitless and refers to CircularProgress thickness */
const CIRCULAR_PROGRESS_THICKNESS = 5;

/** Component that shows a spinner next to the text in a button */
export function FaroButtonSpinner(t0) {
  const $ = _c(7);
  const {
    shouldHide: t1,
    loadingIndicatorColor: t2,
    loadingTrackColor: t3,
    size: t4,
    marginLeft: t5
  } = t0;
  const shouldHide = t1 === undefined ? false : t1;
  const loadingIndicatorColor = t2 === undefined ? PALETTE_VARS.primary.main : t2;
  const loadingTrackColor = t3 === undefined ? PALETTE_VARS.common.white : t3;
  const size = t4 === undefined ? CIRCULAR_PROGRESS_SIZE : t4;
  const marginLeft = t5 === undefined ? "16px" : t5;
  if (shouldHide) {
    return null;
  }
  let t6;
  if ($[0] !== loadingIndicatorColor || $[1] !== marginLeft) {
    t6 = {
      marginLeft,
      color: loadingIndicatorColor
    };
    $[0] = loadingIndicatorColor;
    $[1] = marginLeft;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== loadingTrackColor || $[4] !== size || $[5] !== t6) {
    t7 = <CircularProgress dataTestId="faro-button-spinner" size={size} thickness={CIRCULAR_PROGRESS_THICKNESS} trackColor={loadingTrackColor} sx={t6} />;
    $[3] = loadingTrackColor;
    $[4] = size;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}